// packages block
import { SnackbarProvider } from 'notistack'
import { ApolloProvider } from '@apollo/client'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { MsalProvider } from '@azure/msal-react'
// components block
import { CloseButton, SnackbarUtilsConfiguration } from './components/common/Alert'
// others
import { AppContextProvider } from './context/AppContext'
import client from './apollo'
import MainRoutes from './routes'
import customTheme from './theme'
import { AuthContextProvider } from './context'
import { AppProps } from './interfaceTypes'
import TimerProvider from './context/TimerContext'
import { EntryContextProvider } from './context/EntryContext'

export function App({ pca }: AppProps) {
  return (
    <SnackbarProvider
      maxSnack={5}
      autoHideDuration={5000}
      action={key => <CloseButton id={key} />}
      preventDuplicate={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      classes={{ containerRoot: 'snackbarProvider' }}
    >
      <SnackbarUtilsConfiguration />

      <MsalProvider instance={pca}>
        <ApolloProvider client={client}>
          <AuthContextProvider>
            <ThemeProvider theme={customTheme}>
              <CssBaseline />
              <AppContextProvider>
                <EntryContextProvider>
                  <TimerProvider>
                    <MainRoutes />
                  </TimerProvider>
                </EntryContextProvider>
              </AppContextProvider>
            </ThemeProvider>
          </AuthContextProvider>
        </ApolloProvider>
      </MsalProvider>
    </SnackbarProvider>
  )
}

export default App
